"use client";

import { AgentIndustryFilterPopover } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-industry-filter-popover";
import { AgentIndustryMobileFilter } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-industry-mobile-filter";
import { AgentListLanguageFilter } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-list-language-filter";
import { AgentLocationSearchBox } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-location-search-box";
import { AgentNameSearchBox } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-name-search-box";
import { AgentListClearFilters } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-list-clear-filters";
import { AgentSortDropdown } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-sort-dropdown";
import {
  agentsFiltersAtom,
} from "@/app/(saas)/(app)/business-brokers/_components/filters/state";
import { SelectedFilterCount } from "@/components/common/selected-filter-count";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { useAtom } from "jotai";
import { useState } from "react";

export function AgentListFilters() {
  const [filters] = useAtom(agentsFiltersAtom);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  const hasActiveFilters =
    filters.languageIds.length > 0 || filters.specialtyIds.length > 0;

  return (
    <>
      {/* Mobile layout — rendered by both server & client, hidden via CSS on sm+ */}
      <div className="flex flex-col gap-3 sm:hidden">
        <AgentLocationSearchBox />
        <AgentNameSearchBox />

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            className="flex-1 h-10 rounded-full text-sm"
            onClick={() => setMobileFiltersOpen(!mobileFiltersOpen)}
          >
            <Icon icon="ListFilter" className="size-4 mr-1.5" />
            Filters
            {hasActiveFilters && (
              <span className="ml-1.5 bg-[var(--venturu-green-soft)] text-[var(--venturu-green)] text-xs font-semibold px-1.5 py-0.5 rounded-full">
                {filters.languageIds.length + filters.specialtyIds.length}
              </span>
            )}
          </Button>
          <AgentSortDropdown />
          {hasActiveFilters && <AgentListClearFilters />}
        </div>

        {mobileFiltersOpen && (
          <div className="flex flex-col gap-3 p-3 bg-[var(--venturu-gray-50)] rounded-xl">
            <AgentListLanguageFilter />
            <AgentIndustryMobileFilter>
              <Button
                variant="outline"
                className="h-10 rounded-full text-sm w-full"
              >
                <div className="flex items-center gap-2 min-w-0">
                  {filters.specialtyIds.length > 0 && (
                    <SelectedFilterCount count={filters.specialtyIds.length} />
                  )}
                  <span className="overflow-hidden text-ellipsis">
                    Industry
                  </span>
                </div>
                <Icon icon="ChevronDown" className="size-4" />
              </Button>
            </AgentIndustryMobileFilter>
          </div>
        )}
      </div>

      {/* Desktop layout — rendered by both server & client, hidden via CSS below sm */}
      <div className="hidden sm:flex flex-col gap-4 rounded-2xl bg-card/80 ring-1 ring-black/[0.06] p-3 md:p-4">
        <div className="grid grid-cols-2 gap-4">
          <AgentLocationSearchBox />
          <AgentNameSearchBox />
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <AgentIndustryFilterPopover />
          <AgentListLanguageFilter />

          <div className="ml-auto">
            <AgentSortDropdown />
          </div>

          {hasActiveFilters && <AgentListClearFilters />}
        </div>

      </div>
    </>
  );
}

AgentListFilters.displayName = "AgentListFilters";
